"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.CloseIcon = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("rect", { x: "8.41406", y: "7", width: "12", height: "2", rx: "1", transform: "rotate(45 8.41406 7)" }),
    react_1.default.createElement("rect", { x: "7", y: "15.4844", width: "12", height: "2", rx: "1", transform: "rotate(-45 7 15.4844)" })), 'CloseIcon');
exports.default = exports.CloseIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2xvc2VJY29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vaWNvbnMvQ2xvc2VJY29uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxnREFBMEI7QUFDMUIsbURBQWdEO0FBRW5DLFFBQUEsU0FBUyxHQUFHLElBQUEsNkJBQVksRUFDbkM7SUFDRSx3Q0FDRSxDQUFDLEVBQUMsU0FBUyxFQUNYLENBQUMsRUFBQyxHQUFHLEVBQ0wsS0FBSyxFQUFDLElBQUksRUFDVixNQUFNLEVBQUMsR0FBRyxFQUNWLEVBQUUsRUFBQyxHQUFHLEVBQ04sU0FBUyxFQUFDLHNCQUFzQixHQUNoQztJQUNGLHdDQUNFLENBQUMsRUFBQyxHQUFHLEVBQ0wsQ0FBQyxFQUFDLFNBQVMsRUFDWCxLQUFLLEVBQUMsSUFBSSxFQUNWLE1BQU0sRUFBQyxHQUFHLEVBQ1YsRUFBRSxFQUFDLEdBQUcsRUFDTixTQUFTLEVBQUMsdUJBQXVCLEdBQ2pDLENBQ0QsRUFDSCxXQUFXLENBQ1osQ0FBQztBQUVGLGtCQUFlLGlCQUFTLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/CloseIcon.js
// module id = 3526
// module chunks = 25